<button
  type="button"
  class="transfers-card group flex w-full items-center gap-4 rounded-lg border border-border-muted bg-surface-muted py-4 pl-4 pr-6 text-left transition-colors hover:border-border hover:bg-surface-elevated"
  (click)="open()"
>
  <!-- Sized to the budget rows' progress-circle column (pl-4 + 40px token) so the icon shares its optical center. -->
  <span
    class="flex h-category-bucket-progress w-category-bucket-progress shrink-0 items-center justify-center text-text-muted"
    aria-hidden="true"
  >
    <app-ui-icon name="exchange" class="h-6 w-6" />
  </span>
  <span class="flex min-w-0 flex-1 flex-col">
    <span class="truncate text-body-sm font-bold text-text-title">Transfers</span>
    <span class="truncate text-body-xs text-text-muted">
      @if (transactionCount()) {
        {{ transactionCount() }} {{ transactionCount() === 1 ? 'transfer' : 'transfers' }} this month · doesn't count
        toward spending
      } @else {
        Money moved between accounts · doesn't count toward spending
      }
    </span>
  </span>
  <span class="shrink-0 text-body-sm font-semibold tabular-nums text-text-muted">
    {{ balance() | currency }}
  </span>
  <app-ui-icon
    name="chevron-right"
    class="h-6 w-6 shrink-0 text-text-muted transition-transform group-hover:translate-x-0.5"
    aria-hidden="true"
  />
</button>
